import(/* webpackMode: "eager", webpackExports: ["default"] */ "C:\\Users\\hp\\Desktop\\Namaste-Jharkhand\\src\\app\\news-detail-screen\\components\\NewsDetailClient.tsx");
